import { getUserError } from '../../../../components/miscUtils';
import { getColumnInfo } from '../../../../data/analyticsDataSlice';
import { isEncoded, VALTYPES } from '../../../../data/interfaces';
import { getDataTable } from '../../charts/chartDataBindings';
import { convertColumnDataToDisplayString } from '../../helpers/misc';
import { createDbActionVar_Value } from '../helpers/variables';
import { TpDashboardActionContext, TpDbActionStepDefinition as TpDbActionStepTypeDefinition } from '../interfaces';

function getJsonSchema(): any {
  return {
    type: 'object',
    title: 'Get Row Value',
    description:
      'Gets a cell value of a table row, based on the identifier value of that row, and stores that result in a variable.',
    properties: {
      type: { type: 'string', const: 'GetRowValue' },
      id: {
        type: 'string',
        description: 'Identifier of the variable to be created.',
      },
      tableId: {
        type: 'string',
        description: 'Identifier of the data table.',
      },
      colId: {
        type: 'string',
        description: 'Identifier of the column to be stored in the variable',
      },
      rowId: {
        type: 'string',
        description: 'Identifier of the row for which the value should be fetched',
      },
    },
    required: ['type', 'id', 'tableId', 'colId', 'rowId'],
  };
}

function execute(ctx: TpDashboardActionContext, step: any, onCompleted: () => void) {
  const tableId = step.tableId;
  const dataTable = getDataTable(ctx.dataContext, tableId);
  const colInfo = getColumnInfo(dataTable, step.colId);
  const rowId = step.rowId;
  if (!(rowId in dataTable.itemIdMap)) throw getUserError(`Row ${rowId} not found in table ${tableId}}`);
  const rowIdx = dataTable.itemIdMap[rowId];
  let result = dataTable.columnData[colInfo.id][rowIdx];
  if (colInfo.valueType == VALTYPES.MULTICAT) {
    // For multi-valued categoricals, we want to keep an array, with each individual element converted to the displayed string
    result = result.map((item: any) => convertColumnDataToDisplayString(colInfo, item));
  } else {
    if (isEncoded(colInfo.valueType)) result = convertColumnDataToDisplayString(colInfo, result);
  }
  createDbActionVar_Value(ctx, step.id, result);
  onCompleted();
}

const dbActionStepTypeGetRowValue: TpDbActionStepTypeDefinition = {
  stepType: 'GetRowValue',
  execute,
  getJsonSchema,
};

export default dbActionStepTypeGetRowValue;
